"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = ({
  size = 12,
  width = size,
  height = size,
  ...restProps
}) => /*#__PURE__*/_react.default.createElement("svg", _extends({
  width: width,
  height: height,
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, restProps), /*#__PURE__*/_react.default.createElement("path", {
  d: "M10.9453 0H1.05469C0.473133 0 0 0.473133 0 1.05469V10.9453C0 11.5269 0.473133 12 1.05469 12H10.9453C11.5269 12 12 11.5269 12 10.9453V1.05469C12 0.473133 11.5269 0 10.9453 0ZM11.2969 1.05469V5.64844H6.35156V0.703125H10.9453C11.1392 0.703125 11.2969 0.860836 11.2969 1.05469ZM1.05469 0.703125H5.64844V5.64844H0.703125V1.05469C0.703125 0.860836 0.860836 0.703125 1.05469 0.703125ZM0.703125 10.9453V6.35156H5.64844V11.2969H1.05469C0.860836 11.2969 0.703125 11.1392 0.703125 10.9453ZM10.9453 11.2969H6.35156V6.35156H11.2969V10.9453C11.2969 11.1392 11.1392 11.2969 10.9453 11.2969Z",
  fill: "#121213"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M2.13281 3.53906H2.83594V4.24219C2.83594 4.43634 2.99334 4.59375 3.1875 4.59375C3.38166 4.59375 3.53906 4.43634 3.53906 4.24219V3.53906H4.24219C4.43634 3.53906 4.59375 3.38166 4.59375 3.1875C4.59375 2.99334 4.43634 2.83594 4.24219 2.83594H3.53906V2.13281C3.53906 1.93866 3.38166 1.78125 3.1875 1.78125C2.99334 1.78125 2.83594 1.93866 2.83594 2.13281V2.83594H2.13281C1.93866 2.83594 1.78125 2.99334 1.78125 3.1875C1.78125 3.38166 1.93866 3.53906 2.13281 3.53906Z",
  fill: "#121213"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M3.68435 8.8124L4.18153 8.31522C4.31883 8.17792 4.31883 7.95534 4.18153 7.81804C4.04426 7.68077 3.82165 7.68077 3.68435 7.81804L3.18717 8.31522L2.69 7.81804C2.55272 7.68077 2.33011 7.68077 2.19282 7.81804C2.05552 7.95534 2.05552 8.17792 2.19282 8.31522L2.69 8.8124L2.19282 9.30958C2.05552 9.44688 2.05552 9.66946 2.19282 9.80676C2.33011 9.94406 2.5527 9.94406 2.69 9.80676L3.18717 9.30958L3.68435 9.80676C3.82165 9.94406 4.04424 9.94406 4.18153 9.80676C4.31883 9.66946 4.31883 9.44688 4.18153 9.30958L3.68435 8.8124Z",
  fill: "#121213"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M9.86719 7.75781H7.75781C7.56366 7.75781 7.40625 7.91522 7.40625 8.10938C7.40625 8.30353 7.56366 8.46094 7.75781 8.46094H9.86719C10.0613 8.46094 10.2188 8.30353 10.2188 8.10938C10.2188 7.91522 10.0613 7.75781 9.86719 7.75781Z",
  fill: "#121213"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M9.86719 9.16406H7.75781C7.56366 9.16406 7.40625 9.32147 7.40625 9.51562C7.40625 9.70978 7.56366 9.86719 7.75781 9.86719H9.86719C10.0613 9.86719 10.2188 9.70978 10.2188 9.51562C10.2188 9.32147 10.0613 9.16406 9.86719 9.16406Z",
  fill: "#121213"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M7.75781 3.53906H9.86719C10.0613 3.53906 10.2188 3.38166 10.2188 3.1875C10.2188 2.99334 10.0613 2.83594 9.86719 2.83594H7.75781C7.56366 2.83594 7.40625 2.99334 7.40625 3.1875C7.40625 3.38166 7.56366 3.53906 7.75781 3.53906Z",
  fill: "#121213"
}));

exports.default = _default;